import { useState } from 'react';
import Image from '@atoms/Image';
import Text from '@atoms/Text';
import { PlusIcon } from '@heroicons/react/solid';

const AccordionItem = ({ question, answer, subQuestions, note, defaultOpen = false , ansBackgroundColor = 'bg-basicWhite' }) => {
    const [isOpen, setIsOpen] = useState(defaultOpen);

    return (
        <div className="z-30 ">
            <div
                className={`flex gap-2 cursor-pointer items-baseline md:items-center`}
                onClick={() => setIsOpen((val) => !val)}
            >
                <PlusIcon
                    className={`inline duration-100 transition-transform !w-3 md:!w-5 shrink-0 ${isOpen
                        ? 'rotate-45 text-primary-500 font-semibold'
                        : 'text-gray-400'
                        }`}
                />
                <Text
                    className={`${isOpen
                        ? 'text-primary-500 font-semibold'
                        : 'text-gray-600'
                        } text-base md:text-lg lg:text-xl`}
                    content={question}
                    htmlTag='h4'
                />
            </div>

            <div className={`p-4 mt-2 ml-5 rounded-lg ${ansBackgroundColor} p4-regular text-primary-500 md:p3-regular ${isOpen ? 'block' : 'hidden'}`}>
                    <Text
                        content={answer}
                        className={` ${subQuestions?.length > 0 ? 'mb-4' : ''}`}
                    />
                    <ul className="ml-4 list-disc marker:text-primary-500">
                        {subQuestions?.map(({ question, answer }, index) => (
                            <li key={index} className="mb-2">
                                {question && (
                                    <span className="p4-semibold md:p3-semibold">
                                        {question}
                                        {'- '}
                                    </span>
                                )}
                                {answer}
                            </li>
                        ))}
                    </ul>
                    {note && (<Text content={note} />)}
            </div>
        </div>
    );
};

export default AccordionItem;
